import toGoogleMapsPath from '@/fields/utils/toGoogleMapsPath';

export default function toGoogleMapsPolygon(coordinates: number[][][]): google.maps.MVCArray<google.maps.LatLng>[] {
  return coordinates.map((coordinate) => toGoogleMapsPath(coordinate));
}
